<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5">Modificar Plan de Pago Predeterminado</v-card-title>
        <v-card-text>
          <p>
            Este plan estara disponible como plan de pago predefinido para ser seleccionado en las unidades de negocio a
            aplicarse, al crear o editar un programa.
          </p>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model.trim="input.nombre" label="* Nombre del plan" dense outlined hide-details />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="input.unidad_negocio_id"
                :items="unidades"
                :loading="loadingunidades"
                label="* Unidad de negocio aplicable"
                item-value="id"
                item-text="text"
                hide-details
                dense
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-btn :disabled="!input.unidad_negocio_id" dense @click="openConceptosmodal()" outlined color="blue">
                + Seleccionar conceptos
              </v-btn>
              <br />
              <small style="line-height:0;line-spacing:0">
                La cantidad de cuotas y el monto podran ser cambiados al editar o crear un programa, no se podra cambiar
                a un valor mayor al maximo de cuotas ingresado por cada concepto.
              </small>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="input.conceptos"
                :itemsPerPage="-1"
                class="elevation-2"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:[`item.max_cuotas`]="{ item }">
                  <v-text-field
                    v-model.number="item.max_cuotas"
                    class="end-input"
                    dense
                    outlined
                    hide-details
                    type="number"
                  />
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom v-if="item.inscritos != 0">
                    <template #activator="{ on, attrs }">
                      <v-icon class="red--text" v-bind="attrs" v-on="on" @click="eliminarconcepto(item)">
                        mdi-delete
                      </v-icon>
                    </template>
                    Eliminar Concepto
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = !dialog">Cerrar</v-btn>
          <v-btn color="green darken-1" dark tile @click="save()">Guardar cambios</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Conceptos ref="xconceptosmodal" v-on:conceptos_sel="conceptos_sel" :opcionales="false" />
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import Conceptos from '@/views/promociones/listar-conceptos.vue';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      loadingunidades: false,
      unidades: [],
      msg: '',
      headers: [
        // { text: '#', value: 'nro', width: 30 },
        { text: 'Concepto', value: 'nombre' },
        { text: 'Max. Cuotas', value: 'max_cuotas', width: 150 },
        { text: '', value: 'actions', width: 50 },
      ],
      input: {
        nombre: '',
        unidad_negocio_id: null,
        conceptos: [
          {
            concepto_pago_id: 1,
            nombre: 'matricula',
            max_cuotas: 4,
          },
        ],
      },
    }),
    components: { Conceptos },
    methods: {
      openmodal(item) {
        this.dialog = true;
        this.input = {};
        this.msg = '';
        this.input.conceptos = [];
        this.get_unidades(item);
      },
      openConceptosmodal() {
        let units = [];
        units.push({ id: this.input.unidad_negocio_id });
        this.$refs.xconceptosmodal.openmodal(units);
      },
      conceptos_sel(units) {
        let datos = [];
        units.forEach((x, i) => {
          datos.push({ nro: i + 1, concepto_pago_id: x.id, nombre: x.nombre, max_cuotas: 0 });
        });
        if (units.length > 0) {
          this.input.conceptos = datos;
        }
        window.console.log(datos);
      },
      eliminarconcepto(item) {
        this.input.conceptos = this.input.conceptos.filter((x) => x.concepto_pago_id != item.concepto_pago_id);
      },
      async get_unidades(item) {
        let vue = this;
        this.loadingunidades = true;
        this.unidades = [];
        let s = ` query { NegociosAll { id nombre } }`;
        var sql = gql`
          ${s}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.NegociosAll;
            dat.map((x) => {
              x.text = `[${x.id}] ${x.nombre}`;
            });
            vue.unidades = dat;
            vue.loadingunidades = false;
            vue.getdata(item.id);
          })
          .catch((error) => {
            vue.loadingunidades = false;
            window.console.error(error);
          });
      },
      getdata(id) {
        let vue = this;
        this.loading = true;

        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos/${id}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            vue.input = data;
            vue.loading = false;
            //vue.getunidad(data.unidad_negocio_id);
            window.console.log(data);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      save() {
        let vue = this;
        this.msg = '';
        if (this.input.conceptos.length == 0) this.msg = 'Seleccione los conceptos';
        if (!this.input.unidad_negocio_id) this.msg = 'Seleccione la unidad';
        if (!this.input.nombre) this.msg = 'Ingrese nombre';
        if (this.msg) return;
        this.input.conceptos.forEach((x) => {
          if (!x.max_cuotas || x.max_cuotas < 0) vue.msg = 'Numero max cuotas invalido.';
        });
        if (this.msg) return;
        this.loading = true;

        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos`,
          headers: {},
          data: this.input,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(data);
            vue.$emit('onreg');
            setTimeout(() => {
              vue.dialog = false;
              vue.loading = false;
            }, 600);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
